// extracted by mini-css-extract-plugin
module.exports = {"content":"SubsidyFAQGroup_content__2WkJt","header":"SubsidyFAQGroup_header__2gDkp","body":"SubsidyFAQGroup_body__39RNO","sending":"SubsidyFAQGroup_sending__3qeSG"};